export default __webpack_public_path__ + "static/media/social-icon-github.cf147980.svg";